// src/pages/auth/Logout.jsx
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function Logout() {

  const { logout } = useAuth();
  const navigate = useNavigate();
  const executed = useRef(false); // 🔥 evita doble ejecución

  useEffect(() => {

    if (executed.current) return;
    executed.current = true;

    const doLogout = async () => {
      try {
        await logout();
      } catch (err) {
        console.error("[LOGOUT ERROR]", err);
      } finally {
        navigate("/", { replace: true });
      }
    };

    doLogout();

  }, [logout, navigate]);

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "4rem",
        fontFamily: "Questrial, sans-serif",
      }}
    >
      <p
        style={{
          color: "#264763",
          fontSize: "1.2rem",
          marginBottom: "1rem",
        }}
      >
        Cerrando sesión…
      </p>

      <div
        style={{
          width: "36px",
          height: "36px",
          margin: "0 auto",
          border: "4px solid #cce3f5",
          borderTop: "4px solid #264763",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}